module.exports = __webpack_public_path__ + "static/img/nineBox.d6a88cd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/nineBox.png
// module id = HMBR
// module chunks = 1